import _taggedTemplateLiteral from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
import { jsx as e, jsxs as r } from "react/jsx-runtime";
import { calculateRem as t } from "@vds-core/utilities";
import { ColorTokens as n } from "@vds-tokens/color";
import { LayoutTokens as i } from "@vds-tokens/layout";
import { TypographyTokens as a } from "@vds-tokens/typography";
import o from "styled-components";
import { ComponentTokens as l } from "@vds-tokens/component";
var u = function u(e, r) {
    return "red" === e || "black" === e ? n.palette.white.value : "yellow" === e || "white" === e ? n.palette.black.value : "green" === e || "orange" === e || "blue" === e || "grayHighContrast" === e ? n.elements.primary.inverse["on".concat(r)].value : "grayLowContrast" === e ? n.elements.primary["on".concat(r)].value : n.elements.primary.ondark.value;
  },
  d = {
    kind: "simple",
    surface: "light",
    fillColor: "red",
    containerSize: "16px",
    dotSize: "4px",
    size: "small",
    borderColor: {
      onlight: n.palette.white.value,
      ondark: n.palette.black.value
    },
    hideBorder: !1,
    hideDot: !1,
    maximumDigits: "two",
    leadingCharacter: "",
    trailingText: ""
  },
  c = o.div.withConfig({
    displayName: "BadgeIndicatorWrapper",
    componentId: "VDS__sc-6vasdc-0"
  })(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n"]))),
  s = o.div.withConfig({
    displayName: "StyledBadgeIndicator",
    componentId: "VDS__sc-6vasdc-1"
  })(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  background-color: ", ";\n\n  height: ", ";\n  min-width: ", ";\n  border-radius: ", ";\n  justify-content: center;\n  align-items: center;\n  ", "\n"])), function (_ref) {
    var e = _ref.$fillColor,
      r = _ref.surface;
    return function (e, r) {
      switch (e) {
        case "red":
        default:
          return n.badges.background.red["on".concat(r)].value;
        case "yellow":
          return n.badges.background.yellow["on".concat(r)].value;
        case "green":
          return n.badges.background.green["on".concat(r)].value;
        case "orange":
          return n.badges.background.orange["on".concat(r)].value;
        case "blue":
          return n.badges.background.blue["on".concat(r)].value;
        case "grayHighContrast":
          return l.badgeindicator.gray.highcontrast["on".concat(r)].value;
        case "grayLowContrast":
          return l.badgeindicator.gray.lowcontrast["on".concat(r)].value;
        case "black":
          return n.badges.background.black["on".concat(r)].value;
        case "white":
          return n.badges.background.white["on".concat(r)].value;
      }
    }(e, r);
  }, function (_ref2) {
    var e = _ref2.$containerSize;
    return t(e);
  }, function (_ref3) {
    var e = _ref3.$containerSize;
    return t(e);
  }, function (_ref4) {
    var e = _ref4.$containerSize;
    return t(e);
  }, function (_ref5) {
    var e = _ref5.$borderColor,
      r = _ref5.$hideBorder;
    return r ? "" : "\n      box-shadow: 0 0 0 ".concat(t(1), " ").concat(e, ";\n      ");
  }),
  g = o.div.withConfig({
    displayName: "StyledDot",
    componentId: "VDS__sc-6vasdc-2"
  })(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  height: ", ";\n  width: ", ";\n  border-radius: ", ";\n"])), function (_ref6) {
    var e = _ref6.$fillColor,
      r = _ref6.surface;
    return u(e, r);
  }, function (_ref7) {
    var e = _ref7.$dotSize;
    return t(e);
  }, function (_ref8) {
    var e = _ref8.$dotSize;
    return t(e);
  }, function (_ref9) {
    var e = _ref9.$dotSize;
    return t(e);
  }),
  f = o.div.withConfig({
    displayName: "StyledNumber",
    componentId: "VDS__sc-6vasdc-3"
  })(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  letter-spacing: ", ";\n  line-height: ", ";\n  color: ", ";\n  padding: ", "\n    ", ";\n"])), function (_ref0) {
    var e = _ref0.size;
    return function (e) {
      var r = "Verizon-NHG-eTX";
      return ["medium", "large", "XLarge", "2XLarge"].includes(e) && (r = "Verizon-NHG-eDS"), r;
    }(e);
  }, function (_ref1) {
    var e = _ref1.size;
    return function (e) {
      switch (e) {
        case "small":
        default:
          return t(a.fontsize.body[12].value);
        case "medium":
          return t(a.fontsize.body[14].value);
        case "large":
          return t(a.fontsize.body[16].value);
        case "XLarge":
          return t(a.fontsize.title[20].value);
        case "2XLarge":
          return t(a.fontsize.title[24].value);
      }
    }(e);
  }, a.fontweight.regular.value, function (_ref10) {
    var e = _ref10.size;
    return function (e) {
      var r = t(0);
      return ["medium", "large"].includes(e) && (r = t(a.letterspacing.wide.value)), r;
    }(e);
  }, function (_ref11) {
    var e = _ref11.size;
    return function (e) {
      switch (e) {
        case "small":
        default:
          return t(12);
        case "medium":
          return t(14);
        case "large":
          return t(a.lineheight.body[16].value);
        case "XLarge":
          return t(a.lineheight.title[20].value);
        case "2XLarge":
          return t(a.lineheight.title[24].value);
      }
    }(e);
  }, function (_ref12) {
    var e = _ref12.$fillColor,
      r = _ref12.surface;
    return u(e, r);
  }, function (_ref13) {
    var e = _ref13.padding;
    return function (e) {
      return e && e.vertical ? t(e.vertical) : t(2);
    }(e);
  }, function (_ref14) {
    var e = _ref14.size,
      r = _ref14.padding;
    return function (e, r) {
      var n = t(i.space["1X"].value);
      return ["medium", "large", "XLarge"].includes(e) ? n = t(6) : "2XLarge" === e && (n = t(i.space["2X"].value)), r && r.horizontal ? t(r.horizontal) : n;
    }(e, r);
  }),
  m = o.span.withConfig({
    displayName: "TrailingTextWrapper",
    componentId: "VDS__sc-6vasdc-4"
  })(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  white-space: nowrap;\n"]))),
  p = function p(t) {
    var i = t.kind,
      a = t.surface,
      o = t.fillColor,
      l = t.borderColor,
      u = t.hideBorder,
      d = t.hideDot,
      p = t.children,
      h = t.containerSize,
      $ = t.dotSize,
      v = t.size,
      b = t.padding,
      y = t.maximumDigits,
      w = t.leadingCharacter,
      z = t.trailingText,
      k = t.id,
      S = t.ariaHidden,
      _t$decimalPoints = t.decimalPoints,
      C = _t$decimalPoints === void 0 ? 0 : _t$decimalPoints,
      L = "dark" === a ? l && l.ondark && l.ondark.trim() ? l.ondark : n.palette.black.value : l && l.onlight && l.onlight.trim() ? l.onlight : n.palette.white.value,
      x = function x() {
        var e = {
            one: 9,
            two: 99,
            three: 999,
            four: 9999,
            five: 99999,
            six: 999999,
            none: "none"
          },
          r = y && e[y] ? e[y] : 99,
          t = parseFloat("".concat(p)) || 0;
        if (C > 0) {
          var _e = t.toString().split(".")[0];
          var _r = (t.toString().split(".")[1] || "").slice(0, C).padEnd(C, "0");
          return "".concat(parseInt(_e, 10).toLocaleString("en-Us"), ".").concat(_r);
        }
        return t > r ? "".concat(r.toLocaleString(), "+") : Math.trunc(t).toLocaleString();
      };
    return e(c, {
      children: e(s, {
        kind: i,
        surface: a,
        $fillColor: o,
        id: k,
        $containerSize: function () {
          var e = b && b.vertical,
            r = {
              small: e ? 12 + 2 * parseInt("".concat(e), 10) : 16,
              medium: e ? 14 + 2 * parseInt("".concat(e), 10) : 18,
              large: e ? 16 + 2 * parseInt("".concat(e), 10) : 20,
              XLarge: e ? 20 + 2 * parseInt("".concat(e), 10) : 24,
              "2XLarge": e ? 24 + 2 * parseInt("".concat(e), 10) : 28
            };
          switch (i) {
            case "simple":
              return h || 16;
            case "numbered":
              return v && r[v] ? r[v] : 16;
            default:
              return 16;
          }
        }(),
        size: v,
        padding: b,
        $borderColor: L,
        $hideBorder: u,
        "aria-hidden": S,
        children: "numbered" === i ? r(f, {
          "data-testid": "numberedDiv",
          size: v,
          padding: b,
          surface: a,
          $fillColor: o,
          children: [w && w.trim() && w.trim().charAt(0) ? "".concat(w.trim().charAt(0)).concat(x()) : x(), z && z.trim() && e(m, {
            "data-testid": "trailingText",
            children: " ".concat(z.trim())
          })]
        }) : !d && e(g, {
          $dotSize: parseInt("".concat($), 10) ? $ : 4,
          surface: a,
          $fillColor: o
        })
      })
    });
  };
p.defaultProps = d;
export { p as default };